import * as React from "react";
export const WORKFLOW_ICON_PATHS = {
  robotics: (
    <React.Fragment>
      <rect x="7" y="9" width="10" height="8" rx="2" />
      <path d="M9.5 13h.01M14.5 13h.01M12 9V6" />
      <path d="M5 12H3.5a1.5 1.5 0 0 0 0 3H5" />
      <path d="M19 12h1.5a1.5 1.5 0 0 1 0 3H19" />
      <path d="M9 17v2M15 17v2" />
      <path d="M10 20h4" />
    </React.Fragment>
  ),
  model: (
    <React.Fragment>
      <circle cx="12" cy="12" r="3" />
      <circle cx="5" cy="7" r="2" />
      <circle cx="19" cy="7" r="2" />
      <circle cx="6" cy="18" r="2" />
      <circle cx="18" cy="18" r="2" />
      <path d="M7 8.2 9.6 10M16.4 10 18 8.2M9.6 14 7.5 16.5M14.4 14 16.7 16.5" />
    </React.Fragment>
  ),
  industrial: (
    <React.Fragment>
      <path d="M4 20V9l5 3V9l5 3V6h6v14H4Z" />
      <path d="M7 16h2M11 16h2M15 16h2" />
      <path d="M16 6V4h3v2" />
    </React.Fragment>
  ),
  research: (
    <React.Fragment>
      <path d="M6 4h9a3 3 0 0 1 3 3v13H9a3 3 0 0 1-3-3V4Z" />
      <path d="M9 4v13a3 3 0 0 0 3 3" />
      <path d="M11 8h4M11 12h4" />
      <path d="m16.5 15.5 2.5 2.5M20 14.5a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0Z" />
    </React.Fragment>
  ),
  launch: (
    <React.Fragment>
      <path d="M13 4c3.5.6 6.4 3.5 7 7l-5 5-7-7 5-5Z" />
      <path d="M8 9 5 8l-2 2 4 2" />
      <path d="m15 16 1 3-2 2-2-4" />
      <path d="M9 15 5 19" />
      <circle cx="15" cy="9" r="1.5" />
    </React.Fragment>
  ),
  capture: (
    <React.Fragment>
      <path d="M4 8V6a2 2 0 0 1 2-2h2M16 4h2a2 2 0 0 1 2 2v2M20 16v2a2 2 0 0 1-2 2h-2M8 20H6a2 2 0 0 1-2-2v-2" />
      <circle cx="12" cy="12" r="3" />
      <path d="M12 7v2M12 15v2M7 12h2M15 12h2" />
    </React.Fragment>
  ),
  compiler: (
    <React.Fragment>
      <path d="M4 7h6M4 12h8M4 17h6" />
      <path d="M14 6 20 12l-6 6" />
      <path d="M18 12H9" />
    </React.Fragment>
  ),
  align: (
    <React.Fragment>
      <path d="M5 8h8a4 4 0 0 1 4 4v0a4 4 0 0 1-4 4H5" />
      <path d="m8 5-3 3 3 3M16 13l3 3-3 3" />
      <path d="M9 12h6" />
    </React.Fragment>
  ),
  benchmark: (
    <React.Fragment>
      <path d="M5 20V10M12 20V4M19 20v-7" />
      <path d="M3 20h18" />
      <path d="M10 4h4M3 10h4M17 13h4" />
    </React.Fragment>
  ),
  kitchen: (
    <React.Fragment>
      <path d="M5 4v16M9 4v16" />
      <path d="M5 9h4" />
      <path d="M15 4v8a3 3 0 0 0 6 0V4" />
      <path d="M18 15v5" />
      <path d="M14 20h8" />
    </React.Fragment>
  ),
};
export const WorkflowIcon = ({ name, className = "" }) => (
  <svg
    aria-hidden="true"
    className={className}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.7"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    {WORKFLOW_ICON_PATHS[name]}
  </svg>
);
